import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from "@angular/material/bottom-sheet";
import { NgxSpinnerService } from "ngx-spinner";
import { AlertService } from "src/app/share/service/alert.service";
import { ResetPasswordValidators } from "../../class/reset-password-validators";
import { UserDataService } from "../../data-service/user.data.service";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.scss"],
})
export class ChangePasswordComponent implements OnInit {
  hide: boolean = true;
  formGroup: FormGroup;
  submitted: boolean = false;

  newPassLength: boolean = false;
  repeatNewPassLength: boolean = false;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ChangePasswordComponent>,
    private ngxSpinnerService: NgxSpinnerService,
    private alertService: AlertService,
    private userDataService: UserDataService,
    @Inject(MAT_BOTTOM_SHEET_DATA) data: any
  ) {}

  ngOnInit(): void {
    this.formGroup = new FormGroup(
      {
        currentPassword: new FormControl(null, [Validators.required]),
        newPassword: new FormControl(
          null,
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            ResetPasswordValidators.patternValidator(
              new RegExp("(?=.*[0-9])"),
              {
                requiresDigit: true,
              }
            ),
            ResetPasswordValidators.patternValidator(
              new RegExp("(?=.*[a-z])"),
              {
                requiresLowercase: true,
              }
            ),
            ResetPasswordValidators.patternValidator(
              new RegExp("(?=.*[$@^!%*?&])"),
              {
                requiresSpecialChars: true,
              }
            ),
          ])
        ),
        repeatNewPassword: new FormControl(null, [
          Validators.required,
          Validators.minLength(8),
        ]),
      },
      {
        validators: ResetPasswordValidators.MatchValidator,
      }
    );
  }

  submit() {
    this.ngxSpinnerService.show();
    this.submitted = true;
    let obj = {
      oldPassword: this.formGroup.value.currentPassword,
      newPassword: this.formGroup.value.newPassword,
      confirmNewPassword: this.formGroup.value.repeatNewPassword,
    };

    this.userDataService.updatePassword(obj).subscribe({
      next: (x) => {
        this.ngxSpinnerService.hide();
        this.bottomSheetRef.dismiss(true);
        this.alertService.openSnackBar("Successfully updated account password");
      },
      error: (err) => {
        this.ngxSpinnerService.hide();
        if (err.error) {
          this.alertService.openSnackBar(`Error: ${err.error}`);
        } else {
          this.alertService.openSnackBar(`Error updating account password`);
        }
      },
    });
  }

  close(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    event.preventDefault();
  }

  get f() {
    return this.formGroup.controls;
  }

  get requiredValid() {
    return !this.formGroup.controls["newPassword"].hasError("required");
  }

  getNewPasswordLength(value: any) {
    if (value.length < 8) {
      this.newPassLength = false;
    } else {
      this.newPassLength = true;
    }
  }

  getRepeatNewPasswordLength(value: any) {
    if (value.length < 8) {
      this.repeatNewPassLength = false;
    } else {
      this.repeatNewPassLength = true;
    }
  }
}
